import { Column } from 'components/common/layout'
import { SemiBoldText, BaseText, MediumText } from 'components/common/text'
import { ManagerComment } from 'components/dashboard/scouts/profile/manager-comment'
import { ProfileDetailAssessment } from 'components/dashboard/scouts/profile/profile-detail-assessment'
import { theme } from 'infra/theme'
import { useRouter } from 'next/router'
import React from 'react'
import {
  DashboardScoutRequestDetail,
  ScoutRequestAiAssessment,
  ScoutRequestFilterAssessment,
} from 'types/common'
import { hasFitApplicationFulfillment } from 'utils/validations'
import { LineLimitedText } from 'components/scouts/profile-detail/desc-more-view'
import {
  ProfileDetailCoverLetterBox,
  ProfileDetailCoverLetterSectionTitle,
  ProfileDetailSummaryCard,
  ProfileDetailSummaryList,
} from 'components/scouts/profile-detail/styles'
import { PositionApplicationFulfillmentCondition } from 'components/scouts/profile/common/application-fulfillment-condition'
import { ProfileDetailApplicationData } from 'components/scouts/search/profile-detail'

export const ProfileDetailAdditionalInfo: React.FC<{
  data: DashboardScoutRequestDetail & ProfileDetailApplicationData
  isNarrow?: boolean
}> = ({ data, isNarrow }) => {
  const router = useRouter()
  const hasAssessment =
    !!data.aiAssessment &&
    !!data.filterAssessment &&
    (!!data.assessmentScore || data.assessmentScore === 0.0)
  const hasFitFulfillment = data.fulfillments
    ? hasFitApplicationFulfillment(data.fulfillments)
    : false
  const comment = router.pathname.includes('recommended')
    ? data.managerComment
    : data.commonComment
  if (
    !!data.summary?.length ||
    !!comment?.manager ||
    hasAssessment ||
    data.coverLetter ||
    data.joinReason ||
    data.fitReason ||
    hasFitFulfillment
  )
    return (
      <Column style={{ gap: 32 }}>
        {/* 지원자 */}
        {data.fulfillments && hasFitFulfillment && (
          <PositionApplicationFulfillmentCondition
            userName={data.name}
            fulfillments={data.fulfillments}
          />
        )}
        {(data.coverLetter || data.joinReason || data.fitReason) && (
          <ProfileDetailCoverLetterBox>
            <SemiBoldText>지원 메시지</SemiBoldText>
            {data.coverLetter && (
              <LineLimitedText text={data.coverLetter} lineClamp={2} />
            )}
            {data.joinReason && (
              <Column style={{ gap: 4 }}>
                <ProfileDetailCoverLetterSectionTitle>
                  합류하고 싶은 이유
                </ProfileDetailCoverLetterSectionTitle>
                <LineLimitedText text={data.joinReason} lineClamp={2} />
              </Column>
            )}
            {data.fitReason && (
              <Column style={{ gap: 4 }}>
                <ProfileDetailCoverLetterSectionTitle>
                  적합하다 생각하는 이유
                </ProfileDetailCoverLetterSectionTitle>
                <LineLimitedText text={data.fitReason} lineClamp={2} />
              </Column>
            )}
          </ProfileDetailCoverLetterBox>
        )}
        {/* 스카우트 - AI 인재 평가 */}
        {hasAssessment && (
          <ProfileDetailAssessment
            assessmentScore={data.assessmentScore as number}
            aiAssessment={data.aiAssessment as ScoutRequestAiAssessment}
            filterAssessment={
              data.filterAssessment as ScoutRequestFilterAssessment
            }
          />
        )}
        {/* 공통 */}
        {comment && comment.manager && (
          <ManagerComment managerComment={comment} isNarrow={isNarrow} />
        )}
        {!!data.summary?.length && (
          <ProfileDetailSummaryCard>
            {!isNarrow && (
              <BaseText style={{ color: theme.color.gray2 }}>
                AI 프로필 요약
              </BaseText>
            )}
            {isNarrow ? (
              <MediumText>
                {data.summary.map((item) => item.title).join(' / ')}
              </MediumText>
            ) : (
              <ProfileDetailSummaryList>
                {data.summary.map((item, index) => (
                  <div key={index}>
                    <li dangerouslySetInnerHTML={{ __html: item.title }} />
                    <p dangerouslySetInnerHTML={{ __html: item.content }} />
                  </div>
                ))}
              </ProfileDetailSummaryList>
            )}
          </ProfileDetailSummaryCard>
        )}
      </Column>
    )
}
